// extracted by mini-css-extract-plugin
export default {"genericSelect":"GenericStyles_genericSelect__79Zkf","GenericButton":"GenericStyles_GenericButton__8YkiA"};